import { mutatorAction } from 'satcheljs';
import { mobileDeviceFullStore } from '../store/store';
import MobileDeviceStatistics from 'owa-service/lib/contract/MobileDeviceStatistics';
import { getDevicesFromStatistics } from '../utils/getDevicesFromStatistics';

export let resetMobileDevices = mutatorAction(
    'resetMobileDevices',
    (deviceStatistics: MobileDeviceStatistics[]) => {
        let store = mobileDeviceFullStore();
        store.devices = getDevicesFromStatistics(deviceStatistics);
    }
);
